export default __webpack_public_path__ + "static/media/location.9267d9f2.svg";